import * as Task01 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaAbsoluteValueEquationClosedTask";
import { getMaturaTaskTypeCode3 } from "../maturaTaskClassification";
import * as Task02 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaPowerTimesRootClosedTask";
import * as Task03 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaLogCoefSumTruthClosedTask";
import * as Task04 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaRootBinomialClosedTask";
import * as Task05 from "../../generators/dzial10_dowody/temat3_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaMod5SquaresOpenTask";
import * as Task06 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaLinearExtremeInequalityClosedTask";
import * as Task07 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaPolynomialRootsCountClosedTask";
import * as Task08 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaPercentLinearSystemOpenTask";
import * as Task09 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaFactoredQuadraticInequalityOpenTask";
import * as Task10 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaPiecewiseFunctionIntervalsOpenTask";
import * as Task11 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaLinearKIntervalClosedTask";
import * as Task12 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaLinearShiftClosedTask";
import * as Task13 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaAxisZeroPointCanonicalOpenTask";
import * as Task141 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaQuadraticSequenceS3ClosedTask";
import * as Task142 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaQuadraticSequencePFClosedTask";
import * as Task151 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaArithmeticDifferenceClosedTask";
import * as Task152 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaArithmeticSumClosedTask";
import * as Task16 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaGeometricParamClosedTask";
import * as Task17 from "../../generators/dzial5_trygonometria/temat4_zadania_uzupelniajace_maturalne/podtemat1_zamkniete_types/MaturaTrigSinCosIdentityClosedTask";
import * as Task18 from "../../generators/dzial5_trygonometria/temat4_zadania_uzupelniajace_maturalne/podtemat1_zamkniete_types/MaturaTrigTrianglePFClosedTask";
import * as Task191 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaRightTriangleInradiusClosedTask";
import * as Task192 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaRightTriangleCircumradiusClosedTask";
import * as Task20 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaRegularPolygonInscribedAngleClosedTask";
import * as Task21 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaSquaresSimilarityAreaClosedTask";
import * as Task22 from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaParallelLinePointOpenTask";
import * as Task23 from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaCircleSymmetryClosedTask";
import * as Task24 from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaCuboidGeoSequenceVolumeOpenTask";
import * as Task25 from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaSquarePyramidBaseEdgeClosedTask";
import * as Task26 from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaConeHeightClosedTask";
import * as Task27 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaSetsProductSumSignOpenTask";
import * as Task28 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaDigitOnceClosedTask";
import * as Task29 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaMeanScaledABCClosedTask";
import * as Task30 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaStatsTableMeanMedianModeOpenTask";
import * as Task31 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaQuadraticRevenueClosedTask";

export const sheet = {
  id: "cke-p-2025-czerwiec",
  title: "Matura z matematyki 2025 – termin dodatkowy",
  subtitle: "Poziom podstawowy, 4 czerwca 2025",
  sourceLabel: "CKE • Formuła 2023",
  sessionType: "additional",
  taskCount: 31,
  maxPoints: 50,
};

const taskModules = [
  Task01, Task02, Task03, Task04, Task05, Task06, Task07, Task08, Task09,
  Task10, Task11, Task12, Task13, Task141, Task142, Task151, Task152,
  Task16, Task17, Task18, Task191, Task192, Task20, Task21, Task22,
  Task23, Task24, Task25, Task26, Task27, Task28, Task29, Task30, Task31,
];

const pointsByTaskNumber = {
  "1": 1, "2": 1, "3": 1, "4": 1, "5": 3, "6": 1, "7": 1,
  "8": 2, "9": 2, "10": 4, "11": 1, "12": 1, "13": 3,
  "14.1": 1, "14.2": 1, "15.1": 1, "15.2": 1, "16": 1,
  "17": 1, "18": 1, "19.1": 1, "19.2": 1, "20": 1, "21": 1,
  "22": 2, "23": 1, "24": 4, "25": 1, "26": 1, "27": 2,
  "28": 1, "29": 1, "30": 3, "31": 1,
};

const moduleByType = Object.create(null);

function decorateTask(task) {
  const taskNumber = String(task?.source?.taskNumber ?? "");
  const match = /^(\d+)(?:\.(\d+))?$/.exec(taskNumber);
  if (!match) return task;

  const baseNumber = Number(match[1]);
  if (!match[2]) return { ...task, displayBaseNumber: baseNumber };

  return {
    ...task,
    displayBaseNumber: baseNumber,
    maturaGroupId: match[1],
    maturaGroupPart: Number(match[2]),
  };
}

export function generateTasks(variant = "original", generationOptions = {}) {
  return taskModules.map((taskModule) => {
    const original = taskModule.generateTask({ variant: "original", session: "2025_CZE" });
    moduleByType[original.type] = taskModule;
    if (variant !== "random") return decorateTask(original);
    // Wariant losowy: generujemy losowa wersje, ale zachowujemy numer zadania
    // z oryginalu, aby uklad i numeracja arkusza pozostaly spojne.
    const randomTask = taskModule.generateTask({ ...generationOptions, variant: "random", session: "2025_CZE" });
    randomTask.source = { ...(randomTask.source || {}), taskNumber: original.source?.taskNumber };
    moduleByType[randomTask.type] = taskModule;
    return decorateTask(randomTask);
  });
}

export function generatePagedTasks(variant = "original", generationOptions = {}) {
  return generateTasks(variant, generationOptions).map((task, index) => {
    const taskNumber = String(task.source.taskNumber);
    return {
      index,
      task,
      meta: {
        taskNo: taskNumber,
        code3: getMaturaTaskTypeCode3(task),
        maxPoints: pointsByTaskNumber[taskNumber] || 1,
      },
    };
  });
}

function getModule(task) {
  // Restored exercises may render before this sheet has generated any tasks.
  if (!moduleByType[task?.type]) generateTasks("original");
  const taskModule = moduleByType[task?.type];
  if (!taskModule) {
    throw new Error(`Brak modułu oficjalnego zadania: ${task?.type || "unknown"}`);
  }
  return taskModule;
}

export function renderTask(task) {
  return getModule(task).renderTask(task);
}

export function getInteractionSupport(task) {
  const taskModule = getModule(task);
  return {
    renderInput: typeof taskModule.renderInput === "function",
    checkAnswer: typeof taskModule.checkAnswer === "function",
    renderUserAnswer: typeof taskModule.renderUserAnswer === "function",
  };
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return getModule(task).renderInput?.(task, userAnswer, onChange, disabled) ?? null;
}

export function checkAnswer(task, userAnswer) {
  return getModule(task).checkAnswer?.(task, userAnswer) ?? false;
}

export function renderUserAnswer(userAnswer, task) {
  return getModule(task).renderUserAnswer?.(userAnswer, task) ?? null;
}

export function renderAnswer(task) {
  return getModule(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return getModule(task).renderExplanation(task);
}
